import React from 'react';
import { FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

const KontaktInfo = () => {
  return (
    <div className="bg-gray-900 text-white p-4 rounded-lg shadow-lg max-w-xs mx-auto md:max-w-md lg:max-w-sm md:mt-8 mt-4">
      {/* Telefon */}
      <div className="mb-3 flex flex-col items-center text-center">
        <FaPhone className="text-pink-500 text-xl mb-1" />
        <h2 className="text-md font-bold text-pink-500">Telefon</h2>
        <p className="text-sm">062111377</p>
      </div>

      <div className="border-t border-pink-500 my-3"></div>

      {/* Adresa */}
      <div className="mb-3 flex flex-col items-center text-center">
        <FaMapMarkerAlt className="text-pink-500 text-xl mb-1" />
        <h2 className="text-md font-bold text-pink-500">Adresa</h2>
        <p className="text-sm">
          Novi Sad<br />
          Bulevar Evrope 78/1/118
        </p>
      </div>

      <div className="border-t border-pink-500 my-3"></div>

      {/* E-mail */}
      <div className="flex flex-col items-center text-center">
        <FaEnvelope className="text-pink-500 text-xl mb-1" />
        <h2 className="text-md font-bold text-pink-500">E-mail</h2>
        <p className="text-sm">tijana@gmail.com</p>
      </div>
    </div>
  );
};

export default KontaktInfo;
